package xyz.luan.bpc.calculator

import xyz.luan.bpc.Centre
import xyz.luan.bpc.Circle
import xyz.luan.bpc.Problem
import xyz.luan.bpc.operation.MarkingOperation
import xyz.luan.bpc.operation.StepOperation

object Calculator {
    fun process(problem: Problem): Double {
        val firstOperation = problem.circles.firstOrNull()?.steps?.firstOrNull()?.operation
            ?: return StepOperation.PLUS.neutralValue
        var result = firstOperation.neutralValue
        for (circle in problem.circles) {
            for (step in circle.steps) {
                val value = processMarkings(step.operation, step.value, problem.markings)
                result = step.operation.process(result, value)
            }
            if (problem.centre != null) {
                result = processCentre(circle, problem.centre, result)
            }
        }
        return result
    }

    fun processCentre(circle: Circle, centre: Centre, current: Double): Double {
        val circleOperations = circle.steps.map { it.operation }.toSet()
        var result = current
        if (centre.applyTo in circleOperations) {
            for (operation in centre.operations) {
                result = operation.process(result)
            }
        }
        return result
    }

    fun processMarkings(operation: StepOperation, value: Double, markings: Map<Double, MarkingOperation>): Double {
        val marking = markings[value] ?: return value
        return marking.process(operation, value)
    }
}
